import React from "react";
import { styled } from "@mui/material/styles";
import Alert from "@mui/material/Alert";
export default styled(Alert)(function () {
  return {
    "& .MuiAlert-message": {
      width: "100%"
    }
  };
});